import React, { useState } from 'react';
import { MapPin, Save, X, ToggleLeft, ToggleRight } from 'lucide-react';

export default function LocationMaster() {
  // Mock data initialized exactly from the layout visible in Screenshot 2026-06-11 at 6.30.00 PM.jpg
  const [data, setData] = useState([
    { id: 'A', status: 'ACTIVE', code: 'A', name: 'HO', under: 'HO', deptNo: 'HO', nature: '' },
    { id: 'B', status: 'ACTIVE', code: 'B', name: 'Sharjah', under: 'HO', deptNo: '', nature: '' },
    { id: 'C', status: 'ACTIVE', code: 'C', name: '', under: '', deptNo: '', nature: '' },
    { id: 'D', status: 'INACTIVE', code: 'D', name: '', under: '', deptNo: '', nature: '' },
    { id: 'E', status: 'INACTIVE', code: 'E', name: '', under: '', deptNo: '', nature: '' },
    { id: 'F', status: 'INACTIVE', code: 'F', name: '', under: '', deptNo: '', nature: '' },
    { id: 'G', status: 'INACTIVE', code: 'G', name: '', under: '', deptNo: '', nature: '' },
    { id: 'H', status: 'INACTIVE', code: 'H', name: '', under: '', deptNo: '', nature: '' },
    { id: 'I', status: 'INACTIVE', code: 'I', name: '', under: '', deptNo: '', nature: '' },
    { id: 'J', status: 'INACTIVE', code: 'J', name: '', under: '', deptNo: '', nature: '' },
    { id: 'K', status: 'INACTIVE', code: 'K', name: '', under: '', deptNo: '', nature: '' },
    { id: 'L', status: 'INACTIVE', code: 'L', name: '', under: '', deptNo: '', nature: '' },
    { id: 'M', status: 'INACTIVE', code: 'M', name: '', under: '', deptNo: '', nature: '' },
    { id: 'N', status: 'INACTIVE', code: 'N', name: '', under: '', deptNo: '', nature: '' },
    { id: 'O', status: 'INACTIVE', code: 'O', name: '', under: '', deptNo: '', nature: '' },
    { id: 'P', status: 'INACTIVE', code: 'L', name: '', under: '', deptNo: '', nature: '' },
    { id: 'Q', status: 'INACTIVE', code: 'M', name: '', under: '', deptNo: '', nature: '' },
    { id: 'R', status: 'INACTIVE', code: 'N', name: '', under: '', deptNo: '', nature: '' },
    { id: 'S', status: 'INACTIVE', code: 'O', name: '', under: '', deptNo: '', nature: '' },
    { id: 'T', status: 'INACTIVE', code: 'L', name: '', under: '', deptNo: '', nature: '' },
    { id: 'U', status: 'INACTIVE', code: 'M', name: '', under: '', deptNo: '', nature: '' },
    { id: 'V', status: 'INACTIVE', code: 'N', name: '', under: '', deptNo: '', nature: '' },
    { id: 'W', status: 'INACTIVE', code: 'O', name: '', under: '', deptNo: '', nature: '' },
    { id: 'X', status: 'INACTIVE', code: 'L', name: '', under: '', deptNo: '', nature: '' },
    { id: 'Y', status: 'INACTIVE', code: 'M', name: '', under: '', deptNo: '', nature: '' },
    { id: 'Z', status: 'INACTIVE', code: 'N', name: '', under: '', deptNo: '', nature: '' },
  ]);

  // Handle inline property updates dynamically
  const handleChange = (id, field, value) => {
    setData(prevData =>
      prevData.map(row => (row.id === id ? { ...row, [field]: value } : row))
    );
  };

  // Toggle utility for quick active/inactive modern switch representation
  const toggleStatus = (id, currentStatus) => {
    const nextStatus = currentStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
    handleChange(id, 'status', nextStatus);
  };

  const handleUpdateSubmit = () => {
    alert('Location configurations committed and synchronized successfully.');
    console.log('Saved Location Array Payload:', data);
  };

  return (
    <div className="w-full max-w-6xl bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      {/* Website Header */}
      <div className="bg-slate-50 border-b border-slate-200 px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-indigo-50 text-indigo-600 rounded-lg">
            <MapPin size={20} />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-slate-800 tracking-tight">Location</h2>
          </div>
        </div>
      </div>

      {/* Inline Editable Matrix Workspace */}
      <div className="overflow-x-auto max-h-[500px] overflow-y-auto">
        <table className="w-full text-left border-collapse text-sm">
          <thead>
            <tr className="border-b border-slate-200 text-slate-500 bg-slate-50/50 sticky top-0 z-10 backdrop-blur-sm">
              <th className="px-6 py-3 font-medium text-xs tracking-wider uppercase text-slate-400 w-32">Status</th>
              <th className="px-6 py-3 font-medium text-xs tracking-wider uppercase text-slate-400 w-24">Loc Code</th>
              <th className="px-6 py-3 font-medium text-xs tracking-wider uppercase text-slate-400">Loc Name</th>
              <th className="px-6 py-3 font-medium text-xs tracking-wider uppercase text-slate-400">Under (Parent)</th>
              {/* <th className="px-6 py-3 font-medium text-xs tracking-wider uppercase text-slate-400">Dept No</th>
              <th className="px-6 py-3 font-medium text-xs tracking-wider uppercase text-slate-400">Loc Nature</th> */}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 text-slate-700">
            {data.map((item) => (
              <tr key={item.id} className="hover:bg-slate-50/80 transition-colors group">
                {/* Status Switch Column */}
                <td className="px-6 py-2">
                  <button 
                    onClick={() => toggleStatus(item.id, item.status)}
                    className={`flex items-center gap-2 text-xs font-semibold px-2.5 py-1 rounded-full border transition-all ${
                      item.status === 'ACTIVE' 
                        ? 'bg-emerald-50 border-emerald-200 text-emerald-700' 
                        : 'bg-slate-50 border-slate-200 text-slate-400'
                    }`}
                  >
                    {item.status === 'ACTIVE' ? (
                      <>
                        <ToggleRight size={16} className="text-emerald-600" />
                        <span>Active</span>
                      </>
                    ) : (
                      <>
                        <ToggleLeft size={16} className="text-slate-400" />
                        <span>Inactive</span>
                      </>
                    )}
                  </button>
                </td>

                {/* Static Code Column */}
                <td className="px-6 py-2 font-bold text-slate-900 tracking-wide">
                  {item.code}
                </td>

                {/* Inline Loc Name Input */}
                <td className="px-4 py-2">
                  <input
                    type="text"
                    value={item.name}
                    placeholder="Enter location descriptive name..."
                    onChange={(e) => handleChange(item.id, 'name', e.target.value)}
                    className="w-full bg-transparent group-hover:bg-white px-2 py-1.5 text-sm rounded border border-transparent group-hover:border-slate-200 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-100 outline-none transition-all"
                  />
                </td>

                {/* Inline Under Selection Dropdown */}
                <td className="px-4 py-2">
                  <select
                    value={item.under}
                    onChange={(e) => handleChange(item.id, 'under', e.target.value)}
                    className="w-full bg-transparent group-hover:bg-white px-2 py-1.5 text-sm rounded border border-transparent group-hover:border-slate-200 focus:border-indigo-500 focus:bg-white outline-none transition-all cursor-pointer"
                  >
                    <option value="">— Select Parent —</option>
                    <option value="HO">HO (Head Office)</option>
                    <option value="Sharjah">Sharjah Branch</option>
                  </select>
                </td>

                {/* Inline Dept No Input */}
                {/* <td className="px-4 py-2">
                  <input
                    type="text"
                    value={item.deptNo}
                    placeholder="Dept Tag"
                    onChange={(e) => handleChange(item.id, 'deptNo', e.target.value)}
                    className="w-full bg-transparent group-hover:bg-white px-2 py-1.5 text-sm rounded border border-transparent group-hover:border-slate-200 focus:border-indigo-500 focus:bg-white outline-none transition-all"
                  />
                </td> */}

                {/* Inline Loc Nature Input */}
                {/* <td className="px-4 py-2">
                  <input
                    type="text"
                    value={item.nature}
                    placeholder="Nature attributes..."
                    onChange={(e) => handleChange(item.id, 'nature', e.target.value)}
                    className="w-full bg-transparent group-hover:bg-white px-2 py-1.5 text-sm rounded border border-transparent group-hover:border-slate-200 focus:border-indigo-500 focus:bg-white outline-none transition-all"
                  />
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modern Fixed Bottom Action Bar */}
      <div className="bg-slate-50 border-t border-slate-200 px-6 py-4 flex items-center justify-between">
        <span className="text-xs text-slate-400">
          Modifications made in rows are preserved locally until clicking update.
        </span>
        <div className="flex items-center gap-3">
          <button 
            onClick={() => window.history.back()} 
            className="flex items-center gap-2 bg-white hover:bg-slate-100 text-slate-600 font-medium text-sm py-2 px-4 rounded-lg border border-slate-200 transition-colors"
          >
            <X size={16} />
            <span>Close</span>
          </button>
          <button 
            onClick={handleUpdateSubmit} 
            className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white font-medium text-sm py-2 px-5 rounded-lg transition-colors shadow-sm"
          >
            <Save size={16} />
            <span>Update Changes</span>
          </button>
        </div>
      </div>
    </div>
  );
}